import config from 'config'

import { AbstractService } from 'shared/services/AbstractService'
import getLogger from 'shared/logger'
import { stringifyArrayFormatRepeat } from '~/shared/url'

const DEFAULT_AUTOSUGGEST_QUERY = {} as KeywordsAutoSuggest.AutoSuggestQuery

export class KeywordsAutoSuggestApi extends AbstractService implements Services.IKeywordsAutoSuggestService {
  /**
   * Given a AutoSuggestQuery object, request new suggestions from the KeywordsAutoSuggest Service
   *
   * @param query
   * @throws ServiceError
   */
  public async getSuggestions(query: KeywordsAutoSuggest.AutoSuggestQuery = DEFAULT_AUTOSUGGEST_QUERY): Promise<KeywordsAutoSuggest.Response> {
    const { locale, galleryName, keyword, limit, noCache, searchBackend, ...rest } = query

    const url = `v2/Galleries/${encodeURIComponent(galleryName)}/Culture/${encodeURIComponent(locale)}`

    try {
      const { data } = await this.api.get<string[]>(url, {
        params: {
          keywordFragment: keyword,
          limit,
          requestor: noCache ? config.noCacheRequestor : config.appName,
          searchBackend,
          ...rest,
        },
        paramsSerializer: stringifyArrayFormatRepeat,
      })

      const resp = {
        suggestions: data,
        requestUrl: url,
      }

      return resp
    } catch {
      return {
        suggestions: [],
        requestUrl: url,
      }
    }
  }
}

export const KeywordsAutoSuggestService = new KeywordsAutoSuggestApi(config.services.designConductorService, getLogger)
